// Multi-Room Editing Drawer
// User ctrl-clicks to add rooms to multiSelectRoomArray ("mouse-up" on esri-map.vue)
// It will not show unless user is a manager of at least one dept.
// An array of roomKeys ("300A+A316") is sent along with an object describing properties to change
// All rooms in array are updated with any properties that are not NULL.  NULL properties are ignored.
// multiSelectRoomArray is cleared on empty map click.

<template>
<div>
	    	<v-dialog width="500" v-model="delRoomDialog">
				<v-card class="pl-2 pt-1 pr-2">
				        <v-card-title class="headline">Confirm BULK ROOM DELETION</v-card-title>
				        <v-divider></v-divider>
				        <v-card-text class="pt-4 body-2">
				        	Delete the {{roomList.length}} Selected Rooms from Space Database</v-card-text>
				        <v-card-actions>
				          	<v-spacer></v-spacer>
				          	<v-btn color="green darken-1" flat @click.native="delRoomDialog=false">No</v-btn>
				          	<v-btn color="green darken-1" flat 
				          		@click.native="delRooms">Yes
				      	 	 </v-btn>
				        </v-card-actions>
			      	</v-card>
			</v-dialog>

    		<v-card
			    class="ml-3 mr-3 pb-3">
			    <v-toolbar class="mb-3" color="grey darken-3" dark>    
			    	<v-icon>vertical_split</v-icon>			        
			        <v-toolbar-title>Selected Rooms {{roomAreaTotal}}</v-toolbar-title>
			        <v-spacer></v-spacer>
			        <template v-if="multiSelectRoomArray.length>0">

	                    <v-tooltip left v-if="!dv">
	                        <v-btn slot="activator" icon @click.stop="highlightRooms(multiSelectRoomArray, true)">
	                            <v-icon>control_camera</v-icon>
	                        </v-btn>
	                        <span>Center and Apply Color</span>
	                    </v-tooltip>

				        <v-tooltip left>
					        <v-btn icon slot="activator" @click.stop="delRoomDialog = true">
					        	<v-icon>delete_forever</v-icon>
					        </v-btn>
				        	<span>DELETE ROOMS From Database</span>
				        </v-tooltip>

				        <v-tooltip left>
					        <v-btn icon slot="activator" @click="clearArray">
					        	<v-icon>clear</v-icon>
					        </v-btn>
				        	<span>Clear Selection</span>
				        </v-tooltip>

			    	</template>
			    </v-toolbar>

			    <v-layout row wrap class="py-2">  		  
    		
				<v-flex shrink >
					
						<!-- <v-subheader class="bigSub">Rooms</v-subheader> -->
						
						<v-list v-if="roomList.length > 0" class="pl-2 pt-0" style="height: 220px; overflow: auto;">
					        <v-list-tile v-for="(item, index) in roomList" :key="index"
					            @click="previewRoom(item, index)"
					            class="tightlist">
					            <v-card style="padding-top: 3px; padding-bottom: 3px; padding-left: 10px; padding-right: 5px;" 
					            		width="100%" color="#3f51b522"  >

					           	<v-layout class="caption" >
					           		<v-flex xs11 class="mr-1">{{roomListEntry(item)}}</v-flex>
					           		<v-flex><v-icon class="bulklinedeleteicon" @click.stop="roomDelete(item)" small>clear</v-icon></v-flex>
					           	</v-layout>
					           	</v-card>
					        </v-list-tile>
				        </v-list>
				    
		        </v-flex>
		        <v-flex xs9 class="pl-2 pr-3" v-if="!usingDashboard">
		        	<!-- <v-subheader class="bigSub pl-0">Room Preview</v-subheader> -->
		        	<RoomPreviewMulti v-if="BulkRoomEditSideBarOpen"/>
		        </v-flex>
	        </v-layout>
	    	</v-card>

	    	<!-- ASSIGN DEPARTMENTS -->
	        <v-card class="mx-3 mt-4" >
	        	<v-toolbar color="indigo darken-3" dark >			        
			    	<v-icon>transform</v-icon>
			        <v-toolbar-title>Assignment</v-toolbar-title>
			        <v-spacer></v-spacer>
			        <v-tooltip left>
						<EditDepartmentsDialog :dark='true' :add='true'  
							slot="activator" />
						<span>Edit Assignments</span>
					</v-tooltip>
			    </v-toolbar>

			<!-- REPLACE ACCOUNTS LAYOUT ************************************************* --> 	

			    <v-toolbar v-if="isSuperUser" color="indigo darken-2" dark class="mt-5">			        
			    	<v-icon>edit</v-icon>
			        <v-toolbar-title>Accounts</v-toolbar-title>
			        <v-spacer></v-spacer>
			        <v-btn icon @click="showAccounts = !showAccounts">
			          <v-icon>{{showAccounts ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
			        </v-btn>
			    </v-toolbar>

	        	<v-layout v-if="showAccounts" column class="pt-4 pl-4 pr-4 body-1">
	        		<v-autocomplete	
						v-if="accountItems.length>0"
						v-model="accountSelect"				 
						autofocus
						:items="accountItems"
						:filter="customFilterAccountAutocomplete"
						class=""
						flat
						hide-no-data
						hide-details
						label="Select Accounts to apply (Number, DeptID, Name)"
						solo-inverted
						@change="addToAccountList"
						:readonly="accountItems.length==0 ? true : false">
						<template
					        slot="selection"
					        slot-scope="{ item, tile }"
					      >
					      	<v-layout align-center>
					      		<v-flex xs3 class="px-2">						        
							        	{{item.account}}						       
							    </v-flex>
							    <v-flex xs9>
							        <v-list-tile-content>
							          <v-list-tile-title>
							          	{{item.departmentName}} ({{item.deptID}})
							          </v-list-tile-title>
							          <v-list-tile-sub-title> {{item.description}}
							          	</v-list-tile-sub-title>
							        </v-list-tile-content>
							    </v-flex>
					    	</v-layout>
					      </template>
					      <template
					        slot="item"
					        slot-scope="{ item, tile }"
					      >
					      	<v-layout >
					      		<v-flex xs3 class="px-2">						        
							        	{{item.account}}						       
							    </v-flex>
							    <v-flex xs9>
							        <v-list-tile-content>
							          <v-list-tile-title>
							          	{{item.departmentName}} ({{item.deptID}})
							          </v-list-tile-title>
							          <v-list-tile-sub-title> {{item.description}}
							          	</v-list-tile-sub-title>
							        </v-list-tile-content>
							    </v-flex>
					    	</v-layout>
					      </template>
					</v-autocomplete>
					<v-card flat v-if="this.accountsList.length>0" class="mt-3 body-1">
						<v-layout column>
						<v-flex class="body-2">These will REPLACE accounts in selected rooms.<br>
	        				{{this.accountsList}}
	        			</v-flex>
	        			
		        			<v-layout row class="mt-2">
		        				<v-btn color="#a70000" dark class="ml-0"
						       		@click.native="replaceAccounts()">Replace Accounts
						     	</v-btn>
						       	<v-btn color="green darken-1" flat @click.native="clearAccountSelections">Clear</v-btn>
						    </v-layout>   	
					    </v-layout>
	        		</v-card>
	        	</v-layout>	    

	        <!-- Edit People -------------------------------------------------------------------------------------->

	        <BulkRoomEditOccupantPI :roomKeyArray="roomKeyList" />

			<!-- ROOM PROGRAM LAYOUT -->    
			<v-layout column v-if="isSuperUser"> 
			    <v-toolbar v-if="isSuperUser" color="indigo darken-1" dark class="mt-5" >
			        
			    	<v-icon>edit</v-icon>
			        <v-toolbar-title>Program</v-toolbar-title>
			        <v-spacer></v-spacer>
			        <v-btn icon @click="programAddLine">
			          <v-icon>add</v-icon>
			        </v-btn>
			        <v-btn icon @click="showBulkProgram = !showBulkProgram; if (showBulkProgram) { programAddLine() };">
			          <v-icon>{{showBulkProgram ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
			        </v-btn>
			    </v-toolbar>
			    <v-layout v-if="showBulkProgram" column class="pt-2 pl-2 pr-4">

			    	<v-list v-if="isSuperUser" class="ml-2 mt-3" dense >

						<v-list-tile v-if="room" v-for="(item, index) in newPrograms" 
							:key="index"
							class="programListTile">
							
							<v-layout row>
								<v-flex xs2 class="mr-2">						
								  	<v-text-field 
								  		class="body-1"                         
				                        v-model="item.programID"
				                        label="Code"
				                        single-line  
				                        readonly 
				                        flat solo   
				                        hide-details                    
				                        @change="programChanged=true">                   
				                    </v-text-field>
								</v-flex>

								<v-flex xs8 class="mr-2">
									<v-autocomplete
										:items="programs"
										@input="programChanged=true"
										item-text="nameAndID"
										item-value="programID"
										v-model="item.programID"
										cache-items
										class="body-1"
										flat solo
										single-line
										hide-no-data
										hide-details
										label="Program"							
									></v-autocomplete>
								</v-flex>

								<v-flex xs2 class="mr-2">
									<v-text-field 
										reverse
										class="body-1"        
				                        v-model="item.percentage"
				                        label="%"
				                        single-line  
				                        flat solo  
				                        hide-details                      
				                        @change="programChanged=true">                  
				                    </v-text-field>
								</v-flex>

								<v-flex xs1 class="px-2 text-xs-right" style="margin-top: 10px !important;">
									<v-tooltip top>		              				                
						                <v-icon small slot="activator" @click="deleteProgram(index)" color="red lighten-2">close</v-icon>          
							            <span>Delete</span>
						            </v-tooltip>
								</v-flex>

							</v-layout>
						</v-list-tile>
					</v-list>
				<v-flex >
	            	<v-dialog v-if="programChanged" width="500" v-model="programDialog">
						<template v-slot:activator="{ on }">
			            <v-btn  dark class="mt-3 ml-3" v-on="on" color="#a70000">
			            	Replace Programs
			            </v-btn>
			        	</template>
			        	<v-card class="pl-2 pt-1 pr-2">
					        <v-card-title class="headline">Confirm</v-card-title>
					        <v-divider></v-divider>
					        <v-card-text class="pt-4 body-2">
					        	Replace Programs on Selected Rooms?</v-card-text>
					        <v-card-actions>
					          	<v-spacer></v-spacer>
					          	<v-btn color="green darken-1" flat @click.native="programDialog=false">No</v-btn>
					          	<v-btn color="green darken-1" flat 
					          		@click.native="programApply()">Yes
					      	 	 </v-btn>
					        </v-card-actions>
				      	</v-card>
			    	</v-dialog>
		        </v-flex> 
		    	</v-layout>
			</v-layout>

	        	


	        	<v-toolbar color="indigo" dark class="mt-5">
			        
			    	<v-icon>edit</v-icon>
			        <v-toolbar-title>Room Properties</v-toolbar-title>
			        <v-spacer></v-spacer>
			        <v-btn icon @click="showBulkProperties = !showBulkProperties">
			          <v-icon>{{showBulkProperties ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
			        </v-btn>
			    </v-toolbar>

	        	<v-layout v-if="showBulkProperties" column class="pt-2 pl-4 pr-4">
	          		<v-flex class="">
	          			<!-- <v-text-field class="body-1"
	          				v-model="room.floor"
	          				hide-details
	          				@input="changed=true"
	          				label="Floor">
	          			</v-text-field> -->
	          			 <v-autocomplete
		                    :items="bldg.floors"
		                    @input="changed=true"
		                    item-value="floor"
		                    v-model="room.floor"
		                    cache-items
		                    class="body-1"
		                    flat
		                    light
		                    hide-no-data
		                    hide-details
		                    label="Floor"
		                    
		                    ></v-autocomplete>

	          		</v-flex>
		            <v-flex  class="">
		                <v-text-field class="body-1"
		                  v-model="room.areaManual"
		                  hide-details
		                  @input="changed=true"
		                      label="Area (Manual)">  
		                    </v-text-field>
		            </v-flex>
		            <v-flex  class="">
		                <v-text-field class="body-1"
		                  v-model="room.dateInventory"
		                  hide-details
		                  @input="changed=true"
		                      label="InventoryDate">  
		                    </v-text-field>
		            </v-flex>
		            <v-flex  class="">
		                <v-text-field class="body-1"
		                  v-model="room.capacity"
		                  hide-details
		                  @input="changed=true"
		                      label="Capacity">  
		                    </v-text-field>
		            </v-flex>
		            <!-- <v-flex  class="">
		                <v-text-field class="body-1"
		                  v-model="room.tempCapacity"
		                  hide-details
		                  @input="changed=true"
		                      label="Distancing Capacity">  
		                    </v-text-field>
		            </v-flex> -->
		            <v-flex>
		                  <v-autocomplete
		                    :items="typeItems"
		                    @input="changed=true"
		                    item-text="custom"
		                    item-value="typeID"
		                    v-model="room.type"
		                    cache-items
		                    class="body-1"
		                    flat
		                    light
		                    hide-no-data
		                    hide-details
		                    label="Type"
		                    
		                    ></v-autocomplete>
		            </v-flex>
		            <v-flex>
		                  <v-autocomplete
		                :items="useItems"
		                @input="changed=true"
		                item-text="custom"
		                item-value="useID"
		                v-model="room.use"
		                cache-items
		                class="body-1"                 
		                flat
		                light
		                hide-no-data
		                hide-details
		                label="Use"
		               
		              ></v-autocomplete>
		            </v-flex>
		            <v-flex>
		                  <v-autocomplete
		                :items="classifications"
		                @input="changed=true"
		                item-text="classificationName"
		                item-value="classificationName"
		                v-model="room.classification"
		                cache-items
		                class="body-1"
		                hide-details
		                light
		                
		                label="Classification"
		               
		              ></v-autocomplete>
		            </v-flex>
		            <v-flex class="" v-if="isSuperUser">	
							<v-text-field
								auto-grow
								@input="changed=true"
								class="body-1"
								label="Comments"
								v-model=room.comment
								hide-details
							></v-text-field>
						
					</v-flex>
					<v-flex>
							<v-text-field
								auto-grow
								@input="changed=true"
								class="body-1"
								label="Dept Manager Comments"
								v-model=room.commentMgr
								
							></v-text-field>
						
		            </v-flex>
            <v-flex v-if="changed"><v-btn dark class="ml-0 mt-3 mb-4" color="#a70000" @click="save">Update Properties</v-btn></v-flex>
		    </v-layout>

            
        	</v-card>
        	

  
</div>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import RoomPreviewMulti from './RoomPreviewMulti'
import Vue from 'vue'
import EditDepartmentsDialog from '@/components/forms/EditDepartmentsDialog'
import BulkRoomEditOccupantPI from './BulkRoomEditOccupantPI'



  	let BulkRoomEditSideBar = {

		data() {
	  		return {
	  			delRoomDialog: false,
	  			assignDialog: false,
	  			programDialog: false,

	  			showBulkProperties: false,
	  			showBulkAssign: false,
	  			showBulkProgram: false,
	  			showAccounts: false,

	  			deptSelect: null,
	  			programSelect: null,
		        collegeSelect: null,
		        accountSelect: null,
		        changed: false,
		        programChanged: false,
			    room: 		{   floor: null, 
				                area: null, 
				                dateInventory: null, 
				                capacity: null, 
				                type: null, 
				                use: null, 
				                classification: null, 
				                comment: null 
		          			},
		        newPrograms: 	[],
				newProgram:{	percentage: null, 
								programID: null, 
							},

				accountsList: [], 
	  		}
		},

		props: [ 'dv', ],

		components : { BulkRoomEditOccupantPI, RoomPreviewMulti, EditDepartmentsDialog },

		created: function () {
			this.fetchAccounts().then((data) => {
					this.accountItems = data					
			})
		},

		computed: {

			...mapState({
				mainSidebarOpen: state => state.ui.mainSidebarOpen,
				BulkRoomEditSideBarOpen: state => state.ui.BulkRoomEditSideBarOpen,
				darkTheme: state => state.ui.darkTheme,
				userManagedDepts: state => state.user.userManagedDepts,
				isSuperUser: state => state.user.isSuperUser,
                depts: state => state.lists.depts,
                colleges: state => state.lists.colleges,
                types: state => state.lists.types,
                uses: state => state.lists.uses,
                classifications: state => state.lists.classifications,
                multiSelectRoomArray: state => state.ui.multiSelectRoomArray,
                bldg: state => state.space.selectedBuilding,
                floor: state => state.ui.currentFloor, 
                programs: state => state.lists.programs,  
                buildingRooms: state => state.space.buildingRooms,  
                clearGraphics: state => state.mapFunctions.clearGraphics,  
                highlightRoomsByKey: state => state.mapFunctions.highlightRoomsByKey,
			}),

			...mapGetters(['getRoom',]),

			typeItems: function () {
				this.types.forEach((item) => item.custom = item.typeID + " - " + item.typeName)
				return this.types
			},

			roomAreaTotal: function () {
				const totalArea = this.roomList.reduce((acc, room) => acc + room.area, 0);
				return "(" + totalArea.toLocaleString(undefined, { maximumFractionDigits: 0 }) + "sf )"
			},

			useItems: function () {
				this.uses.forEach((item) => item.custom = item.useID + " - " + item.useName)
				return this.uses
			},

		    roomList: function () { 
				let roomList = this.multiSelectRoomArray
		      	return roomList ? roomList : []
		    },

		    roomKeyList: function () {
		    	return this.roomList.map((room) => { return room.roomKey })
		    },

		    isSpaceManager: function () {
				if (this.userManagedDepts.length > 0) {
					return true
				}
			},

			usingDashboard: function () {
			if (this.$route.path == '/dashboard/') {
				return true
			} else { return false }
		},

		},

		methods: {
		  	...mapMutations([	'updateContentSidebar', 
		  						'updateBulkRoomEditSideBar',
		  						'setSelectedRoom',
		  						'setDatabaseRoom',
		  						'setSnackText',
		  						'clearMultiSelectRoomArray',
		  						'setBuildingRooms',	
		  						'removeFromMultiSelectRoomArray',	  						]),

		  	...mapActions([		'saveRoomsMulti', 
		  						'fetchBuildingRooms', 
		  						'bulkAssign', 
		  						'bulkProgram', 
		  						'deleteRooms', 
		  						'symbolizeNullFeatureLayer', 
		  						'selectBuilding', 
		  						'fetchFullRoom',
		  						'highlightInitialFeatures',		
		  						'fetchAccounts',  	
		  						'bulkReplaceAccounts',					]),

	  		addToAccountList (item) {
	  			this.accountsList.push(item.account.trim())
	  			this.$nextTick(() => { this.accountSelect = null })
	  		},

	  		customFilterAccountAutocomplete (item, queryText, itemText) {
		        if (queryText.length > 3 ) {
			        return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
			    }
	    	},

	    	replaceAccounts () {
	    		let payload = { 'roomKeyArray' : this.roomList.map((room) => { return room.roomKey }),
	    		                'accounts' : this.accountsList }
	    		this.bulkReplaceAccounts(payload).then((response) => {
	    			this.setSnackText(response)
	    			this.accountsList = []
	    			this.accountSelect = null
					//this.$emit('refresh') // Removed because it clears current selection
	    		})
	    	},

	    	clearAccountSelections () {
	    		this.accountsList = []
	    		this.accountSelect = null
	    	},

	  		roomDelete (item) {
	  			this.removeFromMultiSelectRoomArray(item)
	  			this.highlightRooms(this.multiSelectRoomArray, false)
	  		},

	  		customFilterDept (item, queryText, itemText) {

		        if (queryText.length > 3 ) {
			        return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
			    }
			},

			roomListEntry: function(item) {
		    	let room = item && item.number
		    	let bldg = item && item.bldgAlpha
		    	return bldg + " - " + room
		    },

		    clearArray: function () {
		    	this.clearMultiSelectRoomArray()
		    	
		    	// Only do this on the Multi-Edit on the map
		    	if (this.BulkRoomEditSideBarOpen) {
			    	this.clearGraphics('multihighlightlayer')
			    	this.clearGraphics('highlightlayer')
			    	this.setSelectedRoom(null)
			    	this.setDatabaseRoom(null)
			    }
		    },

		    highlightRooms: function (roomArray, centerAndZoom) {
		    	console.log("Highlight Rooms", roomArray)
                this.clearGraphics('colorlayer')
                this.clearGraphics('multihighlightlayer')
                this.clearGraphics('highlightlayer')

                // This function works for normal (non-initial) features
                this.highlightRoomsByKey(roomArray.map((room) => { return room.roomKey } ), 
                	"rgba(63,81,181, 0.6)" , centerAndZoom)     
 
 				// This will highlight room if its in the initial layer
                let joinKeyArray = []
		    	this.roomList.forEach((room) => { joinKeyArray.push(room.dwgName + '.dwg+' + room.ehandle)	})
                this.highlightInitialFeatures({ 'joinKeyArray': joinKeyArray, 'centerAndZoom': true })    
            },

		    delRooms: function () {		    	
		    	let roomKeyArray = []
		    	this.roomList.forEach((room) => {
		    		roomKeyArray.push(room.roomKey)
		    	})
		    	this.deleteRooms( { 'roomArray': roomKeyArray } ).then((response) => {
		    		this.setSnackText(response)
		    		this.setBuildingRooms([]) // This will ensure getting in touch with the database to re-symbolize 
					this.symbolizeNullFeatureLayer(this.bldg.bldgAlpha)
					this.clearArray()
		    		this.updateBulkRoomEditSideBar(false)
					this.$emit('refresh')
		    	}).then(
					this.delRoomDialog = false
				)
		    },

		    previewRoom: function(room) {
/*		    	this.fetchFullRoom({bldgAlpha: room.bldgAlpha, number: room.number})
		    	.then((data) => this.room = data)*/

		    	//This is dependant on a fresh state.space.buildingRooms
		    	this.selectBuilding(room.bldgAlpha).then(() => {
		    		if (this.buildingRooms.length == 0) { 
		    			this.fetchBuildingRooms(this.bldg.bldgAlpha).then(() => { this.setSelectedRoom(this.getRoom(room.roomKey)) })
			    	} else {  	
			    		this.setSelectedRoom(this.getRoom(room.roomKey))
			    	}
		    	})	
		    	
		    },

		    assign: function() {
		    	this.assignDialog = false
		    	let payload = { 'roomKeyArray' : this.roomList.map((room) => { return room.roomKey }), 
		    					'deptID': this.deptSelect.deptID
		    				  }
		    	console.log(payload)
		    	this.bulkAssign(payload).then((response) => {
		    		this.setSnackText(response)
			    	this.deptSelect = null
			    	this.setSelectedRoom(null)
			    	this.fetchBuildingRooms(this.bldg.bldgAlpha)
			    	this.showBulkAssign = false
		    	})


		    },

		    programAddLine: function () {
		    	this.newPrograms.push({...this.newProgram})
		    },

		    deleteProgram: function (index) {
		    	console.log("Delete", index)
		    	console.log(this.newPrograms)
		    	this.$delete(this.newPrograms, index)
		    	console.log(this.newPrograms)
		    },

		    programApply: function() {
		    	
		    	let payload = { 'roomKeyArray' : this.roomList.map((room) => { return room.roomKey }), 
		    					'programs': this.newPrograms
		    				  }
		    	this.programDialog = false
		    	console.log(payload)
		    	this.bulkProgram(payload).then((response) => {
		    		this.setSnackText(response)
		    		if (!response.includes("Not Saved")) {
		    			this.newPrograms = []
		    			this.showBulkProgram = false
						//this.$emit('refresh') // Removed because it clears current selection
		    		}
		    	})
		    },

		    save: function() {
	    	    console.log("Save Clicked")
		      	let localPayload = { roomArray: [], attributes : {} }
		      	//console.log(this.multiSelectRoomArray)
		      	localPayload.roomArray = this.multiSelectRoomArray && this.multiSelectRoomArray.map((room) => room.roomKey)
		      	localPayload.attributes = this.room
		     	//console.log(localPayload)
		      	this.saveRoomsMulti(localPayload).then((responseJson) => { 
		      		this.setSnackText(responseJson)
		      		
		      		if (!responseJson.includes("Not saved")) {
		      			this.bldg && this.fetchBuildingRooms(this.bldg.bldgAlpha)
			      		this.setSelectedRoom(null)
			      		this.changed=false

			      		//reset room variable
				      	for (var key in this.room ) { this.room[key] = null }
						//this.$emit('refresh') // Removed because it clears current selection
			      	}
		      	})				    
			},

		// Removed because it clears current selection
		//refreshRooms() {
			//this.$emit('refresh')
		//},
			
		}						
	}
export default BulkRoomEditSideBar
</script>


<style>

.datatile > .v-list__tile {
    align-items:  flex-start;
    height: auto;
    margin-bottom: 10px;
}

.xTile > .v-list__tile {
	height: 60px;
	padding-right: 8px;
}

.bulklinedeleteicon:hover{
   background-color:#FF5555;
}

.tightlist > .v-list__tile {
	height: auto;
	padding-top: 1px;
	padding-bottom: 1px;
}

</style>





// WEBPACK FOOTER //
// src/components/BulkRoomEditSideBarContent.vue